"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * oai-api
 * The OptionsAI API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@options.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The employment status of the applicant
 * @export
 * @enum {string}
 */
var EmploymentStatus;
(function (EmploymentStatus) {
    EmploymentStatus["Employed"] = "EMPLOYED";
    EmploymentStatus["Retired"] = "RETIRED";
    EmploymentStatus["Student"] = "STUDENT";
    EmploymentStatus["Unemployed"] = "UNEMPLOYED";
    EmploymentStatus["SelfEmployed"] = "SELF_EMPLOYED";
})(EmploymentStatus = exports.EmploymentStatus || (exports.EmploymentStatus = {}));
function EmploymentStatusFromJSON(json) {
    return EmploymentStatusFromJSONTyped(json, false);
}
exports.EmploymentStatusFromJSON = EmploymentStatusFromJSON;
function EmploymentStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.EmploymentStatusFromJSONTyped = EmploymentStatusFromJSONTyped;
function EmploymentStatusToJSON(value) {
    return value;
}
exports.EmploymentStatusToJSON = EmploymentStatusToJSON;
